<template lang="html">

        <fieldset class="slds-form-element">
            <legend class="slds-form-element__legend slds-form-element__label">{{label}}</legend>
            <div class="slds-form-element__control">
                <div v-if="!radiomode" class="slds-checkbox_button-group">
                    <span class="slds-button slds-checkbox_button" v-for="(option) in options" v-bind:key="option.id">
                        <input type="checkbox" v-bind:id="label+option.id" v-bind:checked="values[option.label]" v-bind:name="name" v-bind:disabled="option.disabled" v-on:change="change(option)" />
                        <label class="slds-checkbox_button__label" v-bind:for="label+option.id" >
                            <span class="slds-checkbox_faux">{{option.label}}</span>
                        </label>
                    </span>
                </div>
                <div v-if="radiomode" class="slds-radio_button-group">
                    <span class="slds-button slds-radio_button" v-for="(option) in options" v-bind:key="option.id">
                        <input type="radio" v-bind:id="label+option.id" v-bind:value="option.label" v-bind:checked="values[option.label]?true:false" v-bind:name="name" v-on:click.capture.stop.prevent="change(option)" />
                        <label class="slds-radio_button__label" v-bind:for="label+option.id" >
                            <span class="slds-radio_faux">{{option.label}}</span>
                        </label>
                    </span>
                </div>
            </div>
        </fieldset>

</template>

<script>
// v-bind:checked="value==option.value" 
export default {
  name: 'options',
  components: {
  },
  computed: {
  },
  props: {
    label: String,
    name: String,
    options: Array,
    values: Object,
    radiomode: Boolean
  },
  data() {
    return {
    }
  },
  mounted: function() {
  },
  async created() {

  },
  methods: {
    change: function(option) {
        console.log('label:'+option.label);
        this.$emit('change', option.label);
    },
  }
}
</script>

<style scoped>
</style>
